module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Way I See It")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#paeroa"
    }
  }, [_vm._v("Paeroa")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#new-neighbours"
    }
  }, [_vm._v("New Neighbours")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#summer"
    }
  }, [_vm._v("Summer")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#church-welcome"
    }
  }, [_vm._v("Church Welcome")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#no-rain"
    }
  }, [_vm._v("No Rain")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#sounds-of-the-night"
    }
  }, [_vm._v("Sounds of the Night")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#gus"
    }
  }, [_vm._v("Gus")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#the-fall"
    }
  }, [_vm._v("The Fall")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#the-bike-ride"
    }
  }, [_vm._v("The Bike Ride")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#years"
    }
  }, [_vm._v("40 Years")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#the-park"
    }
  }, [_vm._v("The Park")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#seasons-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seasons of Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#calves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calves")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#bugs-in-garden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bugs in Garden")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#hospital-waiting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hospital Waiting")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-physio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Physio")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#autumn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#tapora",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tapora")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-hibiscus-flower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hibiscus Flower")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-birds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birds")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#church",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#i-remember",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Remember")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#lud",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lud")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#occasional-table",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Occasional Table")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#holiday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#mum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mum")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#the-assignment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Assignment")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#aunty-peter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aunty Peter")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#best-mates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Mates")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#easter-thursday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter Thursday")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#grey-silk-bag",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grey Silk Bag")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#the-jones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jones’")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#love-and-cherish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love and Cherish")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#mates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mates")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#the-new-pastor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Pastor")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#farewell-drop-in-centre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farewell Drop in Centre")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#mr-scrooge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mr Scrooge")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#stunt-woman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stunt Woman")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#carrots-bugs-bunny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrots (Bugs Bunny)")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#waharoa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waharoa")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#christchurch-march-2019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christchurch March 2019")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#life-changes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Changes")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#ponderings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ponderings")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#promptings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Promptings")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#mechanical-know-how",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mechanical Know-how")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#philip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philip")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#different-times",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Different Times")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#alan-and-glenys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alan and Glenys")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#waiting-in-line",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting in Line")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#the-drover-jack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drover – Jack")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#ephesians-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 1")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#ephesians-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 2")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#ephesians-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 3")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#ephesians-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 4")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#ephesians-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 5")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#ephesians-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians 6")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#penpals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Penpals")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#fog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fog")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#sayings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#the-mail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mail")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#the-tooth-fairy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tooth Fairy")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#little-box-of-ashes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Box of Ashes")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#the-starling-box",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Starling Box")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#a-famous-saying",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Famous Saying")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#a-great-place-to-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Great Place To Go")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#philippeans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippeans")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#opportunity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opportunity")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#the-mandarin-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mandarin Tree")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#not-there",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not There")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#the-canadians",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Canadians")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#the-out-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Out-House")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#the-nation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nation")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0